"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SuggestedCardBody = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("./styles");

var _baseReactComponents = require("@navinc/base-react-components");

var _yotpo = _interopRequireDefault(require("../common/yotpo"));

var _utils = require("@navinc/utils");

var _offerLinkAttributes = require("../util/offer-link-attributes");

var _jsxRuntime = require("react/jsx-runtime");

var StyledYotpo = (0, _styledComponents["default"])(_yotpo["default"]).withConfig({
  displayName: "StyledYotpo",
  componentId: "sc-ljv8fo-0"
})(["margin-top:8px;a.text-m.text-m{font-size:12px;}span.yotpo-icon{&:before{font-size:12px;}}"]);

var SuggestedCardBody = function SuggestedCardBody(_ref) {
  var _creditCardOffer$imag, _creditCardOffer$imag2, _creditCardOffer$appl;

  var _ref$creditCardOffer = _ref.creditCardOffer,
      creditCardOffer = _ref$creditCardOffer === void 0 ? {} : _ref$creditCardOffer,
      featuredTitle = _ref.featuredTitle,
      yotpo = _ref.yotpo,
      _ref$detailLink = _ref.detailLink,
      detailLink = _ref$detailLink === void 0 ? '' : _ref$detailLink,
      category = _ref.category,
      locationUrl = _ref.locationUrl,
      enterpriseUuid = _ref.enterpriseUuid,
      order = _ref.order,
      referralName = _ref.referralName,
      referralTarget = _ref.referralTarget,
      referralType = _ref.referralType,
      client = _ref.client;

  var onApplyTrack = function onApplyTrack() {
    (0, _utils.tealiumTrack)({
      tealium_event: 'referral',
      action: 'referral',
      category: category,
      label: locationUrl,
      accountId: enterpriseUuid,
      mfSource: creditCardOffer.mfSource,
      offerCategory: "credit-cards ".concat(creditCardOffer.category),
      offerId: creditCardOffer.id,
      offerName: creditCardOffer.name,
      offerSubCategory: '',
      offerBrand: creditCardOffer.issuer,
      order: order,
      referralName: referralName,
      referralTarget: referralTarget,
      referralType: referralType,
      rtid: creditCardOffer.rtid,
      rsid: creditCardOffer.rsid,
      offerLink: creditCardOffer.applyUrl,
      partnerId: '',
      client: client,
      value: 0
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SuggestedCardBodyWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TitlesWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Header, {
        size: "sm",
        children: featuredTitle || creditCardOffer.name
      }), featuredTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Subtitle, {
        light: true,
        children: creditCardOffer.name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContentWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Logo, {
        src: (_creditCardOffer$imag = (_creditCardOffer$imag2 = creditCardOffer.image) === null || _creditCardOffer$imag2 === void 0 ? void 0 : _creditCardOffer$imag2.high) !== null && _creditCardOffer$imag !== void 0 ? _creditCardOffer$imag : ''
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledYotpo, Object.assign({}, yotpo)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Button, Object.assign({
          rel: "noopener noreferrer",
          target: "_blank",
          size: "large"
        }, (0, _offerLinkAttributes.offerLinkAttributes)((_creditCardOffer$appl = creditCardOffer.applyUrl) !== null && _creditCardOffer$appl !== void 0 ? _creditCardOffer$appl : ''), {
          onClick: onApplyTrack,
          variation: !featuredTitle && 'outline',
          children: "Apply Now"
        }))
      }), detailLink && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Link, {
            href: detailLink,
            target: "_blank",
            rel: "noreferrer",
            children: "See details"
          })
        })
      })]
    })]
  });
};

exports.SuggestedCardBody = SuggestedCardBody;

var _default = (0, _styledComponents["default"])(SuggestedCardBody).withConfig({
  componentId: "sc-ljv8fo-1"
})([""]);

exports["default"] = _default;
//# sourceMappingURL=body.js.map